import Keycloak from "keycloak-js";

let keycloak_url;
let keycloak_realm;
let keycloak_clientid;

if (import.meta.env.MODE && import.meta.env.MODE === "development") {
	keycloak_url = "https://auth-wsfr-dev.io.differangles.fr/auth/";
	keycloak_realm = "WSFR";
	keycloak_clientid = "front-local";
} else if (window.location.hostname.includes("worldskills-france.org")) {
	keycloak_url = "https://auth.worldskills-france.org/auth/";
	keycloak_realm = "WSFR";
	keycloak_clientid = "front";
} else if (window.location.hostname.includes("localhost")) {
	keycloak_url = "https://auth-wsfr-dev.io.differangles.fr/auth/";
	keycloak_realm = "WSFR";
	keycloak_clientid = "front-local";
} else {
	keycloak_url = "https://auth-wsfr-dev.io.differangles.fr/auth/";
	keycloak_realm = "WSFR";
	keycloak_clientid = "front";
}


const keycloak = new Keycloak({
    url: keycloak_url,
    realm: keycloak_realm,
    clientId: keycloak_clientid,
});

export default keycloak;